import React from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import PublHomeData from "./PublHomeData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { IoIosCart } from "react-icons/io";
import { useNavigate } from "react-router-dom";

export default function CategoryPubBody() {
    const phoneNo = useSelector((state) => state.pubLogin.userPhone);
    const categorys = useSelector((state) => state.dropdown.category);
    const navigate = useNavigate();

    const filteredProducts = PublHomeData.filter(
        (product) => product.category === categorys && !product.outOfStock
    );


     const handleCallUs = () => {
        // Replace with your actual phone number
        window.location.href = "tel:+919906644334";
    };
    const handleAddToCart = async (product) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/checkCart`,
                { productName: product.name, customerPhone: phoneNo }
            );

            if (response.data.exists) {
                toast.info(`${product.name} is already in the cart. You can increase the quantity.`, {
                    position: "top-right",
                    autoClose: 3000
                });
            } else {
                const newData = {
                    productName: product.name,
                    productWeight: product.weight,
                    productPrice: product.price,
                    customerPhone: phoneNo
                };

                toast.success(`${product.name} added to cart!`, {
                    position: "top-right",
                    autoClose: 3000
                });

                await axios.post(`${process.env.REACT_APP_API_URL}/pubCart`, newData);
            }
        } catch (error) {
            console.error("Error checking cart:", error.message);
        }
    };

    const handleClick = (product) => {
        navigate("/productPage", { state: { product } });
    };

    const noSelectStyle = {
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        OUserSelect: "none"
    };

    const cardStyle = {
        width: "24rem",
        ...noSelectStyle,
        border: "none",
        borderRadius: "1.5rem",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        overflow: "hidden"
    };

    const videoContainerStyle = {
        position: "relative",
        paddingBottom: "65%",
        height: 0,
        overflow: "hidden"
    };

    return (
        <div className="container-fluid mt-5 mb-5" style={noSelectStyle}>
            <div className="row justify-content-center">
                {filteredProducts.map((product, index) => (
                    <div
                        className="col-lg-4 col-md-4 col-sm-12 mb-4 d-flex justify-content-center"
                        key={index}
                    >
                        {product.category === "Hamper Packages" ? (
                            // VIDEO CARD
                            <div className="card h-100" style={cardStyle} >
                                <div style={videoContainerStyle}>
                                    <video
                                        src={product.videoUrl}
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            borderRadius: "1.5rem"
                                        }}
                                        controls={false}
                                        onContextMenu={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className="card-body d-flex flex-column" style={noSelectStyle}>
                                    <h4
                                        className="card-title"
                                        style={{
                                            fontFamily: "'Playfair Display', serif",
                                            color: "#13547a",
                                            fontWeight: "bold",
                                            fontSize: "1.7rem",
                                            letterSpacing: "1px",
                                            textShadow: "1px 2px 8px #d8eaf3"
                                        }}
                                    >
                                        {product.name}
                                    </h4>
                                    <h4
                                        className="card-text"
                                        style={{
                                            fontFamily: "'Open Sans', sans-serif",
                    color: "#666",
                    fontStyle: "italic",
                    fontSize: "1.05rem",
                    marginTop: "0.6rem",
                    marginBottom: "1.1rem",
                    borderRadius: "8px",
                    padding: "8px 14px",
                    backgroundColor: "transparent"
                                        }}
                                    >
                                        {product.descrption}
                                    </h4>
                                    
                                    <div className="d-flex flex-column align-items-center">
                <button
                    type="button"
                    className="btn btn-outline-primary mt-2 mb-2 text-center btn-lg rounded-pill shadow"
                    onClick={handleCallUs}
                >
                    📞 Call Us
                </button>
            </div>
                                </div>
                            </div>
                        ) : (
                            // IMAGE CARD
                            <div
                                className="card h-100"
                                style={{ ...cardStyle, width: "18rem" }}
                                onClick={() => handleClick(product)}
                            >
                                <img
                                    src={product.img}
                                    className="card-img-top"
                                    alt={product.name}
                                    style={{ height: "200px", objectFit: "cover" }}
                                />
                                <div className="card-body d-flex flex-column" style={noSelectStyle}>
                                    <h4
                                        className="card-title"
                                        style={{
                                            fontFamily: "'Playfair Display', serif",
                                            color: "#13547a",
                                            fontWeight: "bold",
                                            fontSize: "1.7rem",
                                            letterSpacing: "1px",
                                            textShadow: "1px 2px 8px #d8eaf3"
                                        }}
                                    >
                                        {product.name}
                                    </h4>
                                    <h4
                                        className="card-text"
                                        style={{
                                            color: "#21b573",
                                            fontSize: "1.2rem",
                                            marginTop: "0.5rem",
                                            fontWeight: "600",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px"
                                        }}
                                    >
                                        Price: <FaIndianRupeeSign style={{ fontSize: "1.1rem" }} /> {product.price}
                                    </h4>
                                    <h6 className="card-text">Including GST, shipping & packaging</h6>
                                    <h5 style={{   
                                         fontSize: "1.08rem",
                                       color: "#444",
                                      fontWeight: "600",
                                      letterSpacing: "0.3px",
                                        marginTop: "0.4rem"
       
                                      }} >Quantity: {product.weight}</h5>
                                    <div className="mt-auto d-flex justify-content-center">
                                        <button
                                            type="button"
                                            className="btn btn-outline-dark mt-2 mb-2 text-center btn-lg rounded-pill shadow"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAddToCart(product);
                                            }}
                                        >
                                            <IoIosCart /> Add to Cart
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <ToastContainer />
        </div>
    );
}
